import { IMutationWithoutPayload, IMutation } from '@/store/types/mutation'
import { IState } from './types'
import {
  CHECK_SUPPLY_INIT,
  CHECK_SUPPLY_SUCCESS,
  CHECK_SUPPLY_ERROR,
  } from './mutations-types'
import { ISupplyResponse } from '@/api/types/responses'

const mutationCheckSupplyInit: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = true
}

const mutationCheckSupplySuccess: IMutation<IState, ISupplyResponse[]> = (state: IState, supply: ISupplyResponse[]) => {
  state.isLoading = false
  state.supplier = supply
}

const mutationsCheckSupplyError: IMutationWithoutPayload<IState> = (state) => {
  state.isLoading = false
  state.supplier = []
}

export default {
  [CHECK_SUPPLY_INIT]: mutationCheckSupplyInit,
  [CHECK_SUPPLY_SUCCESS]: mutationCheckSupplySuccess,
  [CHECK_SUPPLY_ERROR]: mutationsCheckSupplyError,
}
